import { render, staticRenderFns } from "./aboutus.vue?vue&type=template&id=6398d6ea&scoped=true&"
import script from "./aboutus.vue?vue&type=script&lang=js&"
export * from "./aboutus.vue?vue&type=script&lang=js&"
import style0 from "./aboutus.vue?vue&type=style&index=0&id=6398d6ea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398d6ea",
  null
  
)

export default component.exports